import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Route, Switch, Redirect } from 'react-router-dom';
import ReactGA from 'react-ga';

import Header from '../Header';
import SideNav from '../SideNav';
import HelpContainer from '../../containers/HelpContainer';
import PreferencesContainer from '../../containers/PreferencesContainer';
import DashboardContainer from '../../containers/DashboardContainer';
import ConversationContainer from '../../containers/ConversationContainer';
import VoicemailsContainer from '../../containers/VoicemailsContainer';
import BillingContainer from '../../containers/BillingContainer';
import PlansContainer from '../../containers/PlansContainer';
import IntegrationContainer from '../../containers/IntegrationContainer';
import StaffContainer from '../../containers/StaffContainer';
import ServicesContainer from '../../containers/ServicesContainer';
import SchedulesContainer from '../../containers/SchedulesContainer';
import SetupContainer from '../../containers/SetupContainer';
import WebchatContainer from '../../containers/WebchatContainer';
import OutreachContainer from '../../containers/OutreachContainer';
import AddCampaign from '../../containers/OutreachAddContainer';
import FormResponseAdd from '../../containers/FormResponseAddContainer';
import LeadEngageContainer from '../../containers/LeadEngageContainer';
import FormResponseReport from '../../containers/FormResponseReportContainer';
import AccountSettings from '../../containers/AccountSettings';
import ManageStaff from '../../containers/ManageStaff';
import WebBooking from '../../containers/WebBookingContainer';
import ForbiddenContainer from '../../containers/ForbiddenContainer';
import CampaignsContainer from '../../containers/CampaignsContainer';
import DentalScheduleContainer from '../../containers/DentalScheduleContainer';
import ScheduleDefinitionContainer from '../../containers/ScheduleDefinitionContainer';
import ScheduleBlocksContainer from '../../containers/ScheduleBlocksContainer';
import ServiceTypesContainer from '../../containers/ServiceTypesContainer';
import StaffMappingContainer from '../../containers/StaffMappingContainer';
import AppointmentReminder from '../../containers/AppointmentReminderContainer';
import ReminderSetupContainer from '../../containers/ReminderSetupContainer';
import BrandAnalyticsContainer from '../../containers/BrandAnalyticsContainer';
import AIAssistsContainer from '../../containers/AIAssistsContainer';
import ServiceAgent from '../../containers/ServiceAgent';
import VoiceAIConfigContainer from '../../containers/VoiceAIConfigContainer';

import utils from '../../lib/utils';

import './index.scss';
const csroles = ['CS_ADMIN', 'CS_SETUP', 'CS_SALES'];
export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      leftSidenav: true,
      pausedBusiness: false,
      headerPopupVisibility: false,
    };
  }
  componentWillMount() {
    const { auth, history, userLoginSuccess } = this.props;
    const user = utils.getCookie('user');
    const domain = utils.getCookie('domain');
    const status = utils.getCookie('subscription_status');
    const features = utils.getCookie('features');
    const domain_keywords = utils.getCookie('domain_keywords');
    const booking_software = utils.getCookie('booking_software');
    const studio_id = utils.getCookie('studio_id');
    const studio_name = utils.getCookie('studio_name');
    const brand_ids = utils.getCookie('brand_ids');
    const role = utils.getCookie('role');
    const is_brand = utils.getCookie('is_brand');
    const dashboard_settings = utils.getCookie('dashboard_settings');
    const isLoggedIn = utils.getCookie('tl_user_login') === true || auth.isLoggedIn;
    if (!isLoggedIn && user && domain) {
      userLoginSuccess({
        user,
        domain,
        status,
        features,
        domain_keywords,
        booking_software,
        brand_ids,
        studio_id,
        studio_name,
        role,
        is_brand,
        dashboard_settings,
      });
    } else if (!auth.isLoggedIn) {
      history.replace('/login');
    }
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.syncLogout);
  }

  syncLogout = (event) => {
    const { history } = this.props;
    if (event.key === 'logout') {
      // Remove cookie and redirect
      document.cookie = 'authToken=; Max-Age=0; path=/';
      try {
        const data = JSON.parse(event.newValue);
        console.log('logout data', data);
        if (csroles.includes(data.role)) {
          history.replace('/cslogin');
        } else {
          history.replace('/login');
        }
      } catch (err) {
        history.replace('/login');
      }
    }
  };
  
  componentDidMount() {
    const { auth } = this.props;
    const features = utils.getCookie('features');
    const addvPopUpClosed = utils.getCookie('addvPopUpClosed');
    window.addEventListener('storage', this.syncLogout);
    if (auth.domain !== 'FITNESS' && !(features?.includes("APPOINTMENT_REMINDER_ENABLED")) && addvPopUpClosed != "true") {
      this.setState({
        headerPopupVisibility: true,
      });
    }
    this.setState({
      pausedBusiness: utils.getCookie('subscription_status') === 'SUSPENDED',
    });

    if (auth.isLoggedIn) {
      this.callInitAPIpostAuth();
    }
    // // Fetch user info
    // this.props.getUser();

    // // Fetch domains
    // this.props.getDomains();

    // // Fetch business info
    // this.props.getBusiness();

    // // Fetch business setup status
    // this.props.getBusinessStatus();

    // // Get list of phone numbers of business
    // this.props.getPhoneList();

    // // Fetch FrontdeskAI text only number
    // this.props.getTextNumber();

    // // Get Studio ID
    // this.props.getMBStudioId();

    // // Get profile completion status
    // this.props.getTasksStatus();

    // // Get Bookings Software Info
    // this.props.getBookingSoftware();

    // // Fetch billing info
    // this.props.getActivePlan();

    // //get Staff List
    // this.props.getStaffListMember();
    // // Fetch voicemails of last 30 days
    // this.props.getVoicemails({
    //   startDate: moment()
    //     .subtract(30, 'days')
    //     .valueOf(),
    //   endDate: moment().valueOf(),
    // });

    this.hideSideNavforMobile();

    //   //get Location accessible for user
    //   this.props.getLocationDetails();

    //   console.log("PROPS",this.props);
    //   const user = utils.getCookie('user');
    //   ReactGA.ga('create', user, 'auto');
  }

  componentWillReceiveProps(nextProps) {
    // On Logout, redirect to login
    if (
      nextProps.auth.isLoggedOut === true &&
      nextProps.auth.isLoggedIn === false
    ) {
      //nextProps.history.replace('/login');
      try {
        const data = JSON.parse(localStorage.getItem('logout'));
        console.log('logout data', data);
        if (csroles.includes(data.role)) {
          nextProps.history.replace('/cslogin');
        } else {
          nextProps.history.replace('/login');
        }
      } catch (err) {
        nextProps.history.replace('/login');
      }
    }
    if (nextProps.softwares && nextProps.softwares.info) {
      this.setState({
        pausedBusiness: this.isPausedBusiness(nextProps.softwares),
      });
    }
    if (
      nextProps.auth.isLoggedIn === true &&
      this.props.auth.isLoggedIn !== nextProps.auth.isLoggedIn &&
      !nextProps.auth.isLoggingOut
    ) {
      this.callInitAPIpostAuth();
    }
    if (
      nextProps.auth?.versionMisMatch === true &&
      !this.props.auth?.versionMisMatch &&
      window.Config?.APP_VERSION
    ) {
      window.location.reload(true);
    }
  }
  callInitAPIpostAuth = () => {
    const role = utils.getCookie('role');
    console.log('ROLE', role);
    // Fetch user info
    this.props.getUser();

    // Fetch Schema for preference display
    this.props.getPreferenceSchema();
    // Fetch domains
    this.props.getDomains();

    // Fetch business info
    this.props.getBusiness();

    // Fetch business setup status
    this.props.getBusinessStatus();

    // Get list of phone numbers of business
    this.props.getPhoneList();

    // Fetch FrontdeskAI text only number
    this.props.getTextNumber();

    // Get Studio ID
    this.props.getMBStudioId();

    // Get profile completion status
    if (role && role === 'ADMIN') {
      this.props.getTasksStatus();
    }

    // Get Bookings Software Info
    this.props.getBookingSoftware();

    // Fetch billing info
    this.props.getActivePlan();

    if (role && role !== 'MARKETING') {
      //get Staff List
      this.props.getStaffListMember();

      const { auth } = this.props;
      const { studio_id } = auth;
      const bzid = this.props.business.id || studio_id;

      this.props.getBusinessDetails(bzid);
      // Fetch voicemails of last 30 days
      // this.props.getVoicemails({
      //   startDate: moment()
      //     .subtract(30, 'days')
      //     .valueOf(),
      //   endDate: moment().valueOf(),
      // });
      //get Location accessible for user

      this.props.getLocationDetails('DASHBOARD_ACCESS');
      this.props.getLocationDetails('CONVERSATION_ACCESS');

      //get intents
      this.props.getGroupIntent();
    }
    console.log('PROPS', this.props);
    const user = utils.getCookie('user');
    ReactGA.ga('create', user, 'auto');
  };
  toggleSideNav = () => {
    if (window.innerWidth <= 768)
      this.setState({
        leftSidenav: !this.state.leftSidenav,
      });
  };

  hideSideNavforMobile = () => {
    if (window.innerWidth < 768) {
      this.setState({
        leftSidenav: false,
      });
    }
  };
  closeAdvPopup = () => {
    utils.setCookie('addvPopUpClosed',true);
    this.setState({
      headerPopupVisibility: false, 
    })
  }
  isPausedBusiness = (softwares) => {
    return !!(
      softwares &&
      softwares.info &&
      softwares.info.subscription_status === 'SUSPENDED'
    );
  };

  render() {
    return (
      <div className="home">
        <Header {...this.props} toggleSideNav={this.toggleSideNav} headerPopupVisibility={this.state.headerPopupVisibility} closeAdvPopup={this.closeAdvPopup} />
        <div className="home__two-column">
          <SideNav
            {...this.props}
            app={this.state}
            propapp={this.props.app}
            headerPopupVisibility={this.state.headerPopupVisibility}
            toggleSideNav={this.toggleSideNav}
          />
          <Route
            exact
            path="/app"
            render={() => <Redirect to="/app/dashboard" />}
          />
          {!this.state.pausedBusiness ? (
            <Switch>
              <Route
                path="/app/dashboard"
                render={(props) => <DashboardContainer {...props} />}
              />
              <Route
                path="/app/brandanalytics"
                render={(props) => <BrandAnalyticsContainer {...props} />}
              />
              <Route
                path="/app/conversation"
                component={ConversationContainer}
              />
              <Route
                path="/app/voicemails"
                render={(props) => <VoicemailsContainer {...props} />}
              />
              <Route
                path="/app/staff"
                render={(props) => <StaffContainer {...props} />}
              />
              <Route
                path="/app/services"
                render={(props) => <ServicesContainer {...props} />}
              />
              <Route
                path="/app/apptreminder"
                render={(props) => <AppointmentReminder {...props} />}
              />
              <Route
                path="/app/remindersetup"
                render={(props) => <ReminderSetupContainer {...props} />}
              />
              <Route
                path="/app/schedules"
                render={(props) => <SchedulesContainer {...props} />}
              />
              <Route
                path="/app/schedulepreview"
                render={(props) => <DentalScheduleContainer {...props} />}
              />
              <Route
                path="/app/scheduledefinition"
                render={(props) => <ScheduleDefinitionContainer {...props} />}
              />
              <Route
                path="/app/scheduleblocks"
                render={(props) => <ScheduleBlocksContainer {...props} />}
              />
              <Route
                path="/app/servicetypes"
                render={(props) => <ServiceTypesContainer {...props} />}
              />
              <Route 
                path="/app/staffmapping"
                render={(props) => <StaffMappingContainer {...props} />}
              />
              <Route
                path="/app/setup"
                render={(props) => <SetupContainer {...props} />}
              />
              <Route
                path="/app/preferences"
                render={(props) => <PreferencesContainer {...props} />}
              />
              <Route
                path="/app/outreach"
                render={(props) => <OutreachContainer {...props} />}
              />
              <Route
                path="/app/leadengage"
                render={(props) => <LeadEngageContainer {...props} />}
              />
              <Route
                path="/app/campaign/:id?"
                render={(props) => <AddCampaign {...props} />}
              />
              <Route
                path="/app/addleadengage/:id?"
                render={(props) => <FormResponseAdd {...props} />}
              />
              <Route
                path="/app/reports/:id?"
                render={(props) => <FormResponseReport {...props} />}
              />
              <Route
                path="/app/webchat"
                render={(props) => <WebchatContainer {...props} />}
              />
              <Route
                path="/app/webbooking"
                render={(props) => <WebBooking {...props} />}
              />
              <Route
                path="/app/billing"
                render={(props) => <BillingContainer {...props} />}
              />
              <Route
                path="/app/plans"
                render={(props) => <PlansContainer {...props} />}
              />
              <Route
                path="/app/integration"
                render={(props) => <IntegrationContainer {...props} />}
              />
              <Route
                path="/app/help/:id?"
                render={(props) => (
                  <HelpContainer {...props} pageId={props.location.pathname} />
                )}
              />
              <Route
                path="/app/accountsettings"
                render={(props) => <AccountSettings {...props} />}
              />
              <Route
                path="/app/managestaff"
                render={(props) => <ManageStaff {...props} />}
              />
              <Route
                path="/app/forbidden"
                render={(props) => <ForbiddenContainer {...props} />}
              />
              <Route
                path="/app/campaigns"
                render={(props) => <CampaignsContainer {...props} />}
              />
              <Route
                path="/app/aiAssists"
                render={(props) => <AIAssistsContainer {...props} />}
              />
              <Route
                path="/app/serviceAgent"
                render={(props) => <ServiceAgent {...props} />}
              />
              <Route
                path="/app/voiceaiconfig"
                render={(props) => <VoiceAIConfigContainer {...props} />}
              />
            </Switch>
          ) : (
            <Switch>
              <Route
                path="/app/dashboard"
                render={(props) => <DashboardContainer {...props} />}
              />
              <Route
                path="/app/voicemails"
                render={(props) => <VoicemailsContainer {...props} />}
              />
              <Route
                path="/app/accountsettings"
                render={(props) => <AccountSettings {...props} />}
              />
              <Route
                path="/app/managestaff"
                render={(props) => <ManageStaff {...props} />}
              />
              <Route
                path="/app/forbidden"
                render={(props) => <ForbiddenContainer {...props} />}
              />
              <Route
                path="/app/aiAssists"
                render={(props) => <AIAssistsContainer {...props} />}
              />
              <Route
                path="/app/serviceAgent"
                render={(props) => <ServiceAgent {...props} />}
              />
              <Route
                  path="/app/voiceaiconfig"
                  render={(props) => <VoiceAIConfigContainer {...props} />}
              />
            </Switch>
          )}
        </div>
      </div>
    );
  }
}

Home.defaultProps = {
  children: [],
  getUser: () => {},
  getDomains: () => {},
  getBusiness: () => {},
  getBusinessStatus: () => {},
  getVoicemails: () => {},
  getPhoneList: () => {},
  getTextNumber: () => {},
  getMBStudioId: () => {},
  getTasksStatus: () => {},
  getBookingSoftware: () => {},
  getActivePlan: () => {},
  userLoginSuccess: () => {},
  auth: {},
};

Home.propTypes = {
  children: PropTypes.node,
  getUser: PropTypes.func,
  getDomains: PropTypes.func,
  getBusiness: PropTypes.func,
  getBusinessStatus: PropTypes.func,
  getVoicemails: PropTypes.func,
  getPhoneList: PropTypes.func,
  getTextNumber: PropTypes.func,
  getMBStudioId: PropTypes.func,
  getTasksStatus: PropTypes.func,
  getBookingSoftware: PropTypes.func,
  getActivePlan: PropTypes.func,
  userLoginSuccess: PropTypes.func,
  auth: PropTypes.shape({}),
};
